module.exports = __webpack_public_path__ + "img/Weapon_242.d64a4bcb.png";